module.exports = __webpack_public_path__ + "img/type6.277e899e.png";